import * as React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';

function Step({ title = "", text = undefined, position = "", children }) {
  return (
    <Box component="li"
      sx={{
        position: "relative",
        p: "0.8rem 4rem",
        pr: "0rem",
        minHeight: "12rem",
        ":not(:last-child)": {
          borderLeft: "3px solid white",
        }
      }}>
      <Typography
        sx={{
          fontSize: "2.4rem",
          fontWeight: 700,
        }}
      >
        {title}
      </Typography>

      <Typography
        sx={{
          marginTop: "1.2rem",
          fontSize: "1.4rem",
          fontWeight: 400,
          color: "#FFFFFFBF",
          textAlign: "justify"
        }}
      >
        {text ?? children ?? ""}
      </Typography>

      <Typography
        sx={{
          position: "absolute",
          top: "0rem",
          left: "0rem",
          transform: "translate(-50%, -1%)",
          fontSize: "3rem",
          borderRadius: "50%",
          fontWeight: 700,
          height: "5rem",
          width: "5rem",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "background.black",
          border: "1px solid background.black",
        }}
      >
        {position}
      </Typography>
    </Box>

  );
}

Step.propTypes = {
  window: PropTypes.func,
};

export default Step;